import { compose, fromPairs, map, toPairs } from 'ramda';

const VALUE_METHOD_MAP = {
    Email: 'get_email',
    IsSiteAdmin: 'get_isSiteAdmin',
    LoginName: 'get_loginName',
    AccountName: 'get_loginName',
    PreferredName: 'get_title',
};

// SharePointUser -> { String: String }
export const getUserProfileValuesFromUser = (user) =>
    compose(
        fromPairs,
        map(([key, methodName]) => [key, user[methodName]()]),
        toPairs,
    )(VALUE_METHOD_MAP);
